interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  /** Use on dark/gradient backgrounds */
  inverted?: boolean;
}

export function StepProgress({ currentStep, totalSteps, inverted = false }: StepProgressProps) {
  return (
    <div className="flex items-center justify-center gap-2">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isCompleted = step < currentStep;
        const isCurrent = step === currentStep;
        return (
          <div key={step} className="flex items-center gap-2">
            <div
              className={[
                'w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-colors duration-200',
                isCompleted
                  ? inverted ? 'bg-white text-violet-700' : 'bg-primary text-primary-foreground'
                  : isCurrent
                  ? inverted
                    ? 'bg-white/30 text-white ring-4 ring-white/20'
                    : 'bg-primary text-primary-foreground ring-4 ring-primary/20'
                  : inverted
                  ? 'bg-white/10 text-white/40'
                  : 'bg-muted text-muted-foreground',
              ].join(' ')}
            >
              {isCompleted ? (
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                step
              )}
            </div>
            {step < totalSteps && (
              <div
                className={[
                  'h-0.5 w-12 transition-colors duration-200',
                  isCompleted
                    ? inverted ? 'bg-white/60' : 'bg-primary'
                    : inverted ? 'bg-white/20' : 'bg-muted',
                ].join(' ')}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
